const getters = {
  token: state => state.user.token,
  refreshToken: state => state.user.refreshToken
};
export default getters;

